/* House of Raayaa v5 — shared chrome behavior.
   Menu drawer · desktop mega menu Escape · scroll reveal · drag-scroll strips ·
   wishlist hearts (localStorage) · card colour dots · ring size table and finder. */
(function () {
  'use strict';

  /* ---- menu drawer (dialog: focus containment + return focus, WCAG 2.2 AA) ---- */
  /* The elements are looked up on each event, not cached: a header reload in the theme editor replaces them. */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  function menuPanel() { return document.getElementById('menuPanel'); }

  function menuIsOpen() { var panel = menuPanel(); return panel && panel.classList.contains('open'); }
  function focusableInMenu(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function openMenu() {
    var panel = menuPanel();
    if (!panel) return;
    var overlay = document.getElementById('menuOverlay');
    var openButton = document.getElementById('hdrMenuBtn');
    var closeButton = document.getElementById('menuCloseBtn');
    panel.removeAttribute('inert');
    panel.classList.add('open');
    if (overlay) overlay.classList.add('open');
    if (openButton) openButton.setAttribute('aria-expanded', 'true');
    if (closeButton) closeButton.focus();
  }
  function closeMenu(keepFocus) {
    var panel = menuPanel();
    if (!panel) return;
    var overlay = document.getElementById('menuOverlay');
    var openButton = document.getElementById('hdrMenuBtn');
    var wasOpen = menuIsOpen();
    panel.classList.remove('open');
    panel.setAttribute('inert', '');
    if (overlay) overlay.classList.remove('open');
    if (openButton) {
      openButton.setAttribute('aria-expanded', 'false');
      if (wasOpen && !keepFocus) openButton.focus(); /* return focus to the opener */
    }
  }
  /* A drawer link to a chapter on the current page (/pages/inspirations#ch-…) does not reload the page:
     close the drawer and move focus to the chapter, which the browser has scrolled to. */
  function followSamePageLink(link) {
    var url = new URL(link.href, location.href);
    if (!url.hash || url.pathname !== location.pathname) return;
    closeMenu(true);
    setTimeout(function () {
      var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!target) {
        var openButton = document.getElementById('hdrMenuBtn');
        if (openButton) openButton.focus();
        return;
      }
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }, 0);
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('#hdrMenuBtn')) openMenu();
    else if (e.target.closest('#menuCloseBtn') || e.target.closest('#menuOverlay')) closeMenu();
    else if (menuIsOpen() && e.target.closest('#menuPanel a[href*="#"]')) followSamePageLink(e.target.closest('a'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menuIsOpen()) { closeMenu(); return; }
    if (e.key === 'Escape') { dismissMegaMenu(); return; }
    if (e.key !== 'Tab' || !menuIsOpen()) return;
    var panel = menuPanel();
    var items = focusableInMenu(panel);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  /* ---- desktop mega menu: Escape dismissal (WCAG 1.4.13) --------------- */
  /* The panel opens on :hover / :focus-within (assets/raayaa.css). Escape adds .mega-dismissed, which hides it
     without moving focus or the pointer. The class clears once both the pointer and focus have left. */
  function dismissMegaMenu() {
    document.querySelectorAll('.nav-mega').forEach(function (item) {
      if (item.matches(':hover') || item.matches(':focus-within')) item.classList.add('mega-dismissed');
    });
  }
  document.addEventListener('mouseout', function (e) {
    var item = e.target.closest && e.target.closest('.nav-mega.mega-dismissed');
    if (!item || (e.relatedTarget && item.contains(e.relatedTarget))) return;
    if (!item.contains(document.activeElement)) item.classList.remove('mega-dismissed');
  });
  document.addEventListener('focusout', function (e) {
    var item = e.target.closest && e.target.closest('.nav-mega.mega-dismissed');
    if (!item || (e.relatedTarget && item.contains(e.relatedTarget))) return;
    if (!item.matches(':hover')) item.classList.remove('mega-dismissed');
  });

  /* ---- scroll reveal (.ed-reveal → .in) ------------------------------ */
  /* The hidden start state applies only under html.js (set in layout/theme.liquid), so content stays visible
     when this script cannot run. */
  var revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function observeReveals(root) {
    root.querySelectorAll('.ed-reveal:not(.in)').forEach(function (el) {
      if (revealObserver) revealObserver.observe(el); else el.classList.add('in');
    });
  }
  observeReveals(document);
  /* Tells the fallback in layout/theme.liquid that reveals are running, so it leaves them alone. */
  window.raayaaRevealsReady = true;
  /* theme editor: a reloaded or added section brings new .ed-reveal elements */
  document.addEventListener('shopify:section:load', function (e) { observeReveals(e.target); });

  /* ---- drag-scroll strips ([data-drag-scroll]) ----------------------- */
  document.querySelectorAll('[data-drag-scroll]').forEach(function (strip) {
    var down = false, startX = 0, startLeft = 0, moved = false;
    strip.style.cursor = 'grab';
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startLeft = strip.scrollLeft;
      strip.style.cursor = 'grabbing'; strip.style.scrollSnapType = 'none';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      strip.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; strip.style.cursor = 'grab';
      /* Glide to the nearest item start, then turn snapping back on. Switching snap on straight away made the
         strip jump to a card as the mouse let go (2026-09-28). */
      var base = strip.getBoundingClientRect().left - strip.scrollLeft;
      var maxLeft = strip.scrollWidth - strip.clientWidth;
      var target = maxLeft;
      Array.prototype.forEach.call(strip.children, function (item) {
        var left = Math.min(item.getBoundingClientRect().left - base, maxLeft);
        if (Math.abs(left - strip.scrollLeft) < Math.abs(target - strip.scrollLeft)) target = left;
      });
      strip.scrollTo({ left: Math.max(0, Math.round(target)), behavior: 'smooth' });
      setTimeout(function () { strip.style.scrollSnapType = ''; }, 450);
      /* A release outside the strip fires no strip click, so clear the drag flag after this event turn;
         otherwise the next tap on a card is swallowed once. */
      setTimeout(function () { moved = false; }, 0);
    });
    strip.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    /* Position indicator under the strip: the shared scroll pager (3 or 5 positions, a tab that follows
       the scroll). The row empties when the strip has nothing to scroll. */
    var dotsHost = document.querySelector('[data-scroll-dots="' + strip.id + '"]');
    if (dotsHost) {
      var pager = null;
      var maxScroll = function () { return Math.max(0, strip.scrollWidth - strip.clientWidth); };
      var syncPager = function () { if (pager) pager.update(maxScroll() ? strip.scrollLeft / maxScroll() : 0); };
      var buildPager = function () {
        var pages = maxScroll() ? Math.max(2, Math.round(strip.scrollWidth / strip.clientWidth)) : 0;
        pager = window.raayaaPager(dotsHost, {
          positions: pages,
          onJump: function (progress) { strip.scrollTo({ left: progress * maxScroll(), behavior: 'smooth' }); }
        });
        syncPager();
      };
      strip.addEventListener('scroll', syncPager, { passive: true });
      /* iOS fires resize when its toolbar collapses on scroll: rebuild only when the strip width changes. */
      var builtWidth = strip.clientWidth;
      window.addEventListener('resize', function () {
        if (strip.clientWidth === builtWidth) return;
        builtWidth = strip.clientWidth;
        buildPager();
      });
      buildPager();
    }
  });

  /* ---- wishlist hearts (localStorage, no account needed) ------------- */
  var WISHLIST_KEY = 'raayaa-wishlist';
  /* When the browser refuses storage (private mode, full quota), the list lives in memory for this page view. */
  var memoryWishlist = null;
  function readWishlist() {
    if (memoryWishlist) return memoryWishlist.slice();
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); memoryWishlist = null; }
    catch (e) { memoryWishlist = list; }
  }
  function paintHearts() {
    var saved = readWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var isSaved = saved.indexOf(button.dataset.productHandle) !== -1;
      button.classList.toggle('saved', isSaved);
      button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = button.dataset.productHandle;
    var saved = readWishlist();
    var index = saved.indexOf(handle);
    if (index === -1) saved.push(handle); else saved.splice(index, 1);
    writeWishlist(saved);
    paintHearts();
  });
  paintHearts();
  document.addEventListener('raayaa:content-updated', paintHearts);
})();

/* Product card colour dots (snippets/product-card.liquid): hover shows that colour's image; click keeps it and
   points the card link at that variant. Leaving the dot returns to the chosen colour, or to the first image. */
(function () {
  function cardImage(card) { return card.querySelector('.well .wimg:not(.wimg-b)'); }
  function showSwatch(button) {
    var card = button.closest('.pcard');
    var image = card && cardImage(card);
    if (!image || !button.dataset.img) return;
    if (image.dataset.firstSrc === undefined) {
      image.dataset.firstSrc = image.getAttribute('src');
      image.dataset.firstSrcset = image.getAttribute('srcset') || '';
      image.dataset.firstPos = image.style.objectPosition;
    }
    image.setAttribute('srcset', button.dataset.srcset || '');
    image.setAttribute('src', button.dataset.img);
    /* data-pos: the colour photo's focal point (snippets/focal-point.liquid); empty keeps the CSS position. */
    image.style.objectPosition = button.dataset.pos || '';
    card.classList.add('sw-on');
  }
  function restoreCard(card) {
    var chosen = card.querySelector('[data-card-swatch][aria-pressed="true"]');
    if (chosen) { showSwatch(chosen); return; }
    var image = cardImage(card);
    if (image && image.dataset.firstSrc !== undefined) {
      image.setAttribute('srcset', image.dataset.firstSrcset);
      image.setAttribute('src', image.dataset.firstSrc);
      image.style.objectPosition = image.dataset.firstPos || '';
    }
    card.classList.remove('sw-on');
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-card-swatch]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var card = button.closest('.pcard');
    card.querySelectorAll('[data-card-swatch]').forEach(function (other) {
      other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
    });
    showSwatch(button);
    var cardLink = card.querySelector('.pcard__link');
    if (button.dataset.variantUrl && cardLink) cardLink.setAttribute('href', button.dataset.variantUrl);
  });
  document.addEventListener('mouseover', function (event) {
    var button = event.target.closest && event.target.closest('[data-card-swatch]');
    if (button) showSwatch(button);
  });
  document.addEventListener('mouseout', function (event) {
    var button = event.target.closest && event.target.closest('[data-card-swatch]');
    if (!button || (event.relatedTarget && button.contains(event.relatedTarget))) return;
    var card = button.closest('.pcard');
    if (card) restoreCard(card);
  });
})();

/* Ring size table (snippets/ring-size-table.liquid): the US / UK-AU switch picks which international column
   shows. Every table on the page follows the same choice. */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-rst-system]');
    if (!button) return;
    var system = button.getAttribute('data-rst-system');
    document.querySelectorAll('[data-rst]').forEach(function (table) {
      table.setAttribute('data-system', system);
      table.querySelectorAll('[data-rst-system]').forEach(function (other) {
        other.setAttribute('aria-pressed', other.getAttribute('data-rst-system') === system ? 'true' : 'false');
      });
    });
  });
})();

/* Ring size finder (snippets/ring-size-finder.liquid): reads the ring size table rows in the same
   [data-rsf-scope] (data-c circumference, data-d diameter, data-us), finds the nearest Indian size for the
   number typed, names it, and lights up its row. Out-of-range numbers get a message, not a guess. A number
   clearly between two sizes also names the neighbour, with the order-two-sizes note. On an exact tie the
   larger size wins. Used on the ring size guide page and in the product page size-guide dialog. The on-screen
   ring sizer (sections/ring-size-guide.liquid) is a finder with no mode buttons: data-rsf-start sets its one mode
   and its loop slider is the input. data-rsf-notes-only keeps the result line for the between-sizes note, because its table already shows the row. */
(function () {
  /* half a size step: a number closer to the next size off the chart gets the range message */
  var slack = { c: 0.45, d: 0.15, us: 0.25 };
  var betweenGap = { c: 0.5, d: 0.2, us: 0.3 };
  function initFinder(finder) {
    var scope = finder.closest('[data-rsf-scope]') || document;
    var table = scope.querySelector('[data-rst]');
    var rows = table ? Array.prototype.slice.call(table.querySelectorAll('tbody tr')) : [];
    var input = finder.querySelector('[data-rsf-input]');
    var label = finder.querySelector('[data-rsf-label]');
    var hint = finder.querySelector('[data-rsf-hint]');
    var unit = finder.querySelector('[data-rsf-unit]');
    var sizeOut = finder.querySelector('[data-rsf-size]');
    var metaOut = finder.querySelector('[data-rsf-meta]');
    var modes = Array.prototype.slice.call(finder.querySelectorAll('[data-rsf-mode]'));
    var mode = finder.getAttribute('data-rsf-start') || 'c';
    function value(row, key) { return parseFloat(row.getAttribute('data-' + key)); }
    function describe(row) {
      var system = table.getAttribute('data-system') === 'uk' ? 'UK/AU ' + row.getAttribute('data-uk') : 'US ' + row.getAttribute('data-us');
      return row.getAttribute('data-c') + ' mm circumference · ' + row.getAttribute('data-d') + ' mm diameter · ' + system;
    }
    function update() {
      rows.forEach(function (row) { row.classList.remove('is-match'); });
      finder.classList.remove('has-result');
      var typed = parseFloat(String(input.value).replace(',', '.'));
      if (!rows.length || isNaN(typed) || typed <= 0) {
        sizeOut.textContent = '–';
        metaOut.textContent = finder.getAttribute('data-empty');
        return;
      }
      var values = rows.map(function (row) { return value(row, mode); });
      var low = Math.min.apply(null, values);
      var high = Math.max.apply(null, values);
      if (typed < low - slack[mode] - 0.001) { sizeOut.textContent = '–'; metaOut.textContent = finder.getAttribute('data-below'); return; }
      if (typed > high + slack[mode] + 0.001) { sizeOut.textContent = '–'; metaOut.textContent = finder.getAttribute('data-above'); return; }
      var best = null;
      var bestGap = Infinity;
      rows.forEach(function (row, i) {
        var gap = Math.abs(values[i] - typed);
        if (gap < bestGap - 0.001 || (Math.abs(gap - bestGap) <= 0.001 && values[i] > value(best, mode))) { best = row; bestGap = gap; }
      });
      var matches = rows.filter(function (row) { return Math.abs(value(row, mode) - value(best, mode)) < 0.001; });
      matches.forEach(function (row) { row.classList.add('is-match'); });
      sizeOut.textContent = matches.map(function (row) { return row.getAttribute('data-size'); }).join(' or ');
      var meta = finder.hasAttribute('data-rsf-notes-only') ? '' : describe(best);
      if (bestGap >= betweenGap[mode] - 0.001) {
        var index = rows.indexOf(best);
        var neighbour = typed > value(best, mode) ? rows[index + 1] : rows[index - 1];
        if (neighbour) meta += (meta ? '. ' : '') + finder.getAttribute('data-between').replace('[size]', neighbour.getAttribute('data-size'));
      }
      metaOut.textContent = meta;
      void finder.offsetWidth;
      finder.classList.add('has-result');
    }
    modes.forEach(function (button) {
      button.addEventListener('click', function () {
        mode = button.getAttribute('data-rsf-mode');
        modes.forEach(function (other) { other.setAttribute('aria-pressed', other === button ? 'true' : 'false'); });
        label.textContent = button.getAttribute('data-label');
        hint.textContent = button.getAttribute('data-hint');
        unit.textContent = button.getAttribute('data-unit');
        input.step = mode === 'us' ? '0.5' : '0.1';
        input.value = '';
        update();
        input.focus();
      });
    });
    input.addEventListener('input', update);
    finder.__rsfUpdate = update;
  }
  /* the US / UK switch changes the result line too. One delegated listener for every finder, so a section
     reload in the theme editor adds no listener and a removed finder is no longer updated. */
  document.addEventListener('click', function (event) {
    if (!(event.target.closest && event.target.closest('[data-rst-system]'))) return;
    setTimeout(function () {
      document.querySelectorAll('[data-rsf-ready]').forEach(function (finder) {
        if (finder.__rsfUpdate) finder.__rsfUpdate();
      });
    }, 0);
  });
  function initAll(root) {
    (root || document).querySelectorAll('[data-rsf]:not([data-rsf-ready])').forEach(function (finder) {
      finder.setAttribute('data-rsf-ready', '');
      initFinder(finder);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  /* theme editor: re-run when a section reloads */
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
